module.exports = __webpack_public_path__ + "static/media/MullerRegular.efd160ca.otf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/font/MullerRegular.otf
// module id = 428
// module chunks = 0